import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../styles/landing/ProductMockup.css';

const MOCKUP_STATS = [
    { key: 'giftsCollected', value: '₪48,250' },
    { key: 'installmentGiftsActive', value: '37 guests' },
    { key: 'nextIncomingPayment', value: '₪6,400' },
    { key: 'giftMessages', value: '124 received' },
    { key: 'walletBalance', value: '₪32,900', suffix: 'available', highlight: true },
] as const;

const ProductMockup: React.FC = () => {
    const { t } = useTranslation();

    return (
        <aside className="product-mockup" aria-label="Product preview">
            <div className="product-mockup__device">
                <div className="product-mockup__chrome">
                    <span className="product-mockup__dot" />
                    <span className="product-mockup__dot" />
                    <span className="product-mockup__dot" />
                    <span className="product-mockup__title">MarryGo</span>
                </div>
                <div className="product-mockup__grid">
                    {MOCKUP_STATS.map((stat) => (
                        <div
                            key={stat.key}
                            className={`product-mockup__stat ${'highlight' in stat && stat.highlight ? 'product-mockup__stat--highlight' : ''}`}
                        >
                            <span className="product-mockup__label">
                                {t(`hero.mockup.${stat.key}`)}
                            </span>
                            <span className="product-mockup__value ltr-value">
                                {stat.value}
                                {'suffix' in stat && stat.suffix && (
                                    <span className="product-mockup__suffix"> {stat.suffix}</span>
                                )}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </aside>
    );
};

export default ProductMockup;
